import { Dropdown, Icon, Modal, PrimaryButton, Shimmer, ShimmerElementType, TextField } from "@fluentui/react";
import React, { useEffect, useState, useContext, useRef } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import themeContext from "../../../../../context/theme/ThemeContext";
import loaderContext from "../../../../../context/loader/LoaderContext";
import toastContext from "../../../../../context/toast/ToastContext";
import { REPORT_TITLE, SHOW_NOT_ORIGNAL_MODALITY_LIST, TOAST_TYPE } from "../../../../../constants/Constants";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import ExternalReporting from "../ExternalReporting/ExternalReporting";
import CustomEditor from "../../../../Report/components/CustomEditorSection/CustomEditor";
import FroalaEditor from "react-froala-wysiwyg";
import RBadge from "../../../../../components/SVGComponents/RBadge";
import PBadge from "../../../../../components/SVGComponents/PBadge";
import DBadge from "../../../../../components/SVGComponents/DBadge";
import LBadge from "../../../../../components/SVGComponents/LBadge";
import CLBadge from "../../../../../components/SVGComponents/CLBadge";
import ShimmerStudyRows from "../../ShimmerStudyList/ShimmerStudyRows";
import LoadingBar from "react-top-loading-bar";
import { getFormattedReport } from "../../../../../service/StudyReportService";


const FormatterAgentModal = (props) => {
  //const { ref, setLoaderRunning, showModal, setShowModal } = useContext(loaderContext);
  const formatterRef = useRef(null);
  const [formatterLoading,setFormatterLoading] = useState(false);
  const [t] = useTranslation();
  const { showToastv2 } = useContext(toastContext);
  const [editReport, setEditReport] = useState(true);
  const [activeTabIndex,setActiveTabIndex] = useState(0);
  const [isFormattedView, setIsFormattedView] = useState(true);
  const editorRef = useRef(null);
  const [currentActiveTab, setCurrentActiveTab] = useState("");
  const [model, setModel] = useState("");
  const isStudyList = true;
  const { themeName } = useContext(themeContext);
  const { studyId, patientReports, setPatientReports, showFormatterPopup, setShowFormatterPopup, setPendingSubmission, setFormattedReportAction, setPendingQCPass} = useContext(studyReportContext);
  const [updatedReports, setUpdatedReports] = useState(patientReports);
  const [errorState, setErrorState] = useState(null);
 
  useEffect(() => {
    if (showFormatterPopup) {
      fetchFormattedReport(false);
    }
  }, [showFormatterPopup]);

  const handleToggleView = (formattedView) => {
    setIsFormattedView(formattedView);
  
    if (formattedView) {
      setModel(
        updatedReports[activeTabIndex]?.reportDetails?.report === undefined
          ? updatedReports[activeTabIndex]?.reportDetails?.finalReport
          : updatedReports[activeTabIndex]?.reportDetails?.report
      );
    } else {
      setModel(
        patientReports[activeTabIndex]?.reportDetails?.report === undefined
          ? patientReports[activeTabIndex]?.reportDetails?.finalReport
          : patientReports[activeTabIndex]?.reportDetails?.report
      );
    }
  };

  useEffect(()=>{
    console.log("updated reports", updatedReports);
  }, [updatedReports])

  const fetchFormattedReport = async (reformat) => {
    console.log("Fetching formatted report", patientReports);
    let timeoutReached = false; 
    const timeoutId = setTimeout(() => {
      timeoutReached = true;
      setErrorState({ message: '⏳ Request timed out. Please try again.' });
    }, 60000);
    try {
      setFormatterLoading(true);

      const studyReportList = []; 
      patientReports.map((ele) => {
        studyReportList.push({
          reportTemplateId : ele.reportDetails?.reportTemplateId || ele.reportDetails?.id,
          reportTemplateTitle : ele.reportDetails?.reportTemplateTitle || ele.reportDetails?.title,
          finalReport : ele.reportDetails?.finalReport || ele.reportDetails?.report
      })
      });
      const body = {
        formatterAgentDto: {
          studyId : studyId,
          studyReportList : studyReportList,
          requestType: reformat ? "REFORMAT" : "FORMAT",
        }
      }

      const response = await getFormattedReport(body);
      console.log(response);
      let i = activeTabIndex;
      response.data.data.map((ele) => {
        updateFinalReport(i, ele.formatted);
        i++;
      })

      clearTimeout(timeoutId);
      if (timeoutReached) return;
      
      if(isFormattedView){
        setModel(response.data.data[activeTabIndex].formatted);
      }
      
      setCurrentActiveTab(patientReports[activeTabIndex].text)
      setFormatterLoading(false);
    } catch (error) {
      console.error("Error fetching formatted report:", error);
      setErrorState({ message: '⚠️ Failed to fetch formatted content. Please try again.' });
      clearTimeout(timeoutId);
    } finally {
      // formatterRef.current.complete();
      // setFormatterLoading(false);
    }
  };

  const updateFinalReport = (index, newContent) => {
    setUpdatedReports((prevReports) => {
      return prevReports.map((report, i) => {
        if (i === index && report?.reportDetails) {
          if (report.reportDetails.finalReport !== undefined) {
            return {
              ...report,
              reportDetails: {
                ...report.reportDetails,
                finalReport: newContent,
              },
            };
          } else if (report.reportDetails.report !== undefined) {
            return {
              ...report,
              reportDetails: {
                ...report.reportDetails,
                report: newContent,
              },
            };
          }
        }
        return report; 
      });
    });
  };

  const updatePatientReport = (index, newContent) => {
    setPatientReports((prevReports) => {
      return prevReports.map((report, i) => {
        if (i === index && report?.reportDetails) {
          if (report.reportDetails.finalReport !== undefined) {
            return {
              ...report,
              reportDetails: {
                ...report.reportDetails,
                finalReport: newContent,
              },
            };
          } else if (report.reportDetails.report !== undefined) {
            return {
              ...report,
              reportDetails: {
                ...report.reportDetails,
                report: newContent,
              },
            };
          }
        }
        return report; 
      });
    });
  };

  const handleChangeTemplate = (val, index) => {
    console.log("-- HandleChangeTemplate ---", val, index);
    let reportDetails =
      val?.reportDetails == undefined ? val.report : val.reportDetails;
    setCurrentActiveTab(
      reportDetails?.report == undefined
        ? reportDetails.reportTemplateTitle
        : reportDetails.title
    );

    setModel(
        reportDetails?.report == undefined
          ? reportDetails?.finalReport
          : reportDetails?.report
      );

    setTimeout(() => {
      handleActiveTab(val);
    }, 100);
  };

  const handleActiveTab = (report) => {
    let element = document.getElementById(report?.text);

    const ulItem = document.getElementById("horizontal-list");
    const listItems = ulItem?.getElementsByTagName("li");
    if (listItems != undefined)
      for (let i = 0; i <= listItems.length - 1; i++) {
        if (listItems[i].id == report?.text) {
          element = listItems[i];
          break;
        }
      }

    if (report != null) {
      if (element != null) {
        if (isStudyList) {
          if (element?.classList != null)
            element?.classList.add(themeName + "-active-li");
        } else {
          if (element?.classList != null) element?.classList.add("active-li");
        }
      }
    }

    if (document.getElementById("horizontal-list") != null) {
      var allTabs = document.getElementById("horizontal-list").children;
      if (allTabs.length > 0) {
        for (var i = 0; i < allTabs.length; i++) {
          if (
            allTabs[i].id != report?.text &&
            report != null &&
            allTabs[i] != null
          ) {
            if (isStudyList) {
              if (allTabs[i].classList.contains(themeName + "-active-li"))
                allTabs[i].classList.remove(themeName + "-active-li");
            } else {
              if (allTabs[i].classList.contains("active-li"))
                allTabs[i].classList.remove("active-li");
            }
          }
        }
      }
    }
  };

  const handleModelChange = (model) => {
    console.log("-- HandleModelChange ---", model);
    if(isFormattedView){
      setUpdatedReports((prevReports) => 
        prevReports.map((ele) => {
          if (currentActiveTab === ele.text) {
            let tempReportDetails = ele.reportDetails ?? { report: ele.report };
            
            if (tempReportDetails.report === undefined) {
              tempReportDetails.finalReport = model;
            } else {
              tempReportDetails.report = model;
            }
    
            return { ...ele, reportDetails: tempReportDetails };
          } 
          return ele;
        })
      );
    }
    setModel(model); 
  };

  let DefaultButtonList = [
    {
      title: errorState != null ? "Skip" : "Reject",
      onclick: () => handleDefaultActions(),
      disabled : formatterLoading && errorState == null
    },
  ];
  
  let PrimaryButtonList = [
    {
      title: errorState != null ? "Retry" : "Accept",
      onclick: () => handlePrimaryAction(),
      disabled: formatterLoading && errorState == null
    },
  ];

  let SecondaryButtonList = [
    {
      title: "Reformat",
      onclick: () => handleSecondaryAction(),
      disabled: formatterLoading
    },
  ];

  const handleDefaultActions = () => {
    if(errorState == null){
      setFormattedReportAction("REJECT");
    }
    setShowFormatterPopup(false);
    setErrorState(null);
  }

  const handlePrimaryAction = () => {
    if (errorState != null ) {
       fetchFormattedReport(false);
     }else{
      if(!checkReportContent()){
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.empty-report"));
        return;
      }
      setFormattedReportAction("ACCEPT");
      replaceReportContent();
      setShowFormatterPopup(false);
     }
    setErrorState(null);
  }

  const handleSecondaryAction = () => {
    fetchFormattedReport(true);
    setErrorState(null);
  }
  
  const replaceReportContent = () => {
    console.log("Accepting the formatted report", updatedReports)
    for(let i = 0; i < updatedReports.length; i++){
      updatePatientReport(i, updatedReports[i].reportDetails?.finalReport 
        ? updatedReports[i].reportDetails?.finalReport 
        : updatedReports[i].reportDetails?.report);
    }
  };

  const handleCancel = () => {
    setShowFormatterPopup(false);
    setPendingSubmission(null);
    setPendingQCPass(null);
  }

  const checkReportContent = () => {
    let opt = getReportContent();
      let matches = [];
      let flag = true;
      opt.map((ele, index) => {
        const aux = document.createElement("div");
        aux.innerHTML = ele.finalReport;
        
        const regexPattern =
          /[^\x09][^\x0A][^\x0D][^\x20][^\x20-\uD7FF][^\uE000-\uFFFD\u{10000}-\u{10FFFF}][^\uD800-\uDBFF]/gu;
        

        if (ele?.finalReport != null && ele.finalReport != undefined) {
          var poweredByFroalaRegex =
            /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

          if (poweredByFroalaRegex.test(ele.finalReport)) {
            // console.log("--- Present Powered by text ----");
            var modifiedHtmlString = ele.finalReport.replace(
              poweredByFroalaRegex,
              ""
            );
            ele.finalReport = modifiedHtmlString;
          } else {
            // console.log("--- Not present powered by text ----");
          }
        }

        if (ele?.addendum != null && ele.addendum != undefined) {
          var poweredByFroalaRegex =
            /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

          if (poweredByFroalaRegex.test(ele.addendum)) {
            // console.log("--- Present Powered by text (addendum) ----");
            var modifiedHtmlString = ele.addendum.replace(
              poweredByFroalaRegex,
              ""
            );
            ele.addendum = modifiedHtmlString;
          } else {
            // console.log("--- Not present powered by text (addendum) ----");
          }
        }

        const trimmedContent = aux.innerText.trim();
        if (ele)
          if (
            trimmedContent == "" ||
            trimmedContent == "Powered by Froala Editor"
          ) {
            flag = false;
          }
      });

      return flag;
  }

  const getReportContent = () => {
    let opt = [];

      updatedReports.map((ele, index) => {
        ele.reportDetails == undefined
          ? (ele.reportDetails = ele.report)
          : (ele.reportDetails = ele.reportDetails);
        if (ele.reportDetails != undefined && ele.reportDetails != null) {
          opt.push({
            reportTemplateId:
              ele.reportDetails.reportTemplateId == undefined
                ? ele.reportDetails.id
                : ele.reportDetails.reportTemplateId,
            reportTemplateTitle:
              ele.reportDetails.title == undefined
                ? ele.reportDetails.reportTemplateTitle
                : ele.reportDetails.title,
            finalReport:
              ele.reportDetails.report == undefined
                ? ele.reportDetails.finalReport
                : ele.reportDetails.report,
            isSuperSpecialReport:
              ele.reportDetails.isSuperSpecialReport == undefined
                ? 0
                : ele.reportDetails.isSuperSpecialReport,
            addendum:
              ele.reportDetails.addendum == undefined
                ? ""
                : ele.reportDetails.addendum,
          });
        }
      });

      return opt;
  }

  const getConfig = (formattedView) => ({
    placeholderText: "Edit Your Content Here!",
    key: process.env.REACT_APP_FROALA_API_KEY,
    attribution: false,
    charCounterCount: false,
    height: 400,
    width: 818,
    fontSize: [
          "8", "9", "10", "10.67", "11", "12", "13", "13.33", "14", "14.67", "15", 
          "16", "17", "17.33", "18", "18.67", "19", "21.33", "24", "30", "36", "48", "60", "72", "96"
        ],
    fontSizeDefault: "12" ,
    fontSizeUnit: "px" ,
    lineHeights: { Default: "1.5", Single: "1", 1.15: "1.15", 1.5: "1.5", Double: "2" },
    fontFamilyDefaultSelection: "Times New Roman, serif",
    paste: formattedView,
    pastePlain: formattedView,
    pasteAllowedStyleProps: [],
    wordPasteModal: false,
    pluginsEnabled: [
          "fullscreen", "codeBeautifier", "colors", "fontFamily", "lineHeight", 
          "fontSize", "paragraphFormat", "paragraphStyle", "align", "lists", "table"
        ],
    toolbarButtons: {
      moreText: {
        buttons: [
          "undo", "redo", "|", "paragraphFormat", "lineHeight", "|", "fontFamily", "|", 
          "fontSize", "|", "bold", "italic", "underline", "|", "fullscreen", "|", 
          "formatOL", "formatUL", "strikeThrough", "clearFormatting", "|", "textColor", 
          "backgroundColor", "|", "alignLeft", "alignCenter", "alignRight", 
          "alignJustify", "outdent", "indent", "|", "insertTable", "|", "copy"
        ],
        align: "left",
        buttonsVisible: 12,
      },
    },
    events: formattedView
      ? { }
      : {
          initialized: function () {
            console.log("-- initializing Froala in read-only mode");
            this.edit.off();
          },
        },
  });

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={<>
          <Icon iconName="AutoEnhanceOn" style={{ marginRight: "10px" }} />
          Report Formatting Agent
        </>}
        handleCancel={() => handleCancel()}
      />
    ),
    body: (<>
       <div className="report-container"style={{filter:"unset"}}>
        {formatterLoading ? <>
          {errorState == null ?
            <Shimmer
              shimmerElements={[{ type: ShimmerElementType.line, height: 553, width: "100%" }]}
              shimmerColors={{
                background: themeName != "light"?"#040910":"white",
                // shimmer: "#2948ff",   // Bluish shimmer
                // shimmerWave: "#1a1a1a", // Dark background
                // background: "#000000",  // Black base
              }}
              style={{ /* position: "absolute", top: 0, */ left: 0, width: "100%", height: "100%" }}
            />
          : (
            <div
              style={{
                backgroundColor: themeName !== "light" ? "#040910" : "white",
                width: "100%",
                height: "553px",
              }}
            />
          )}

          <div style={{
            position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            fontSize: "18px", color: "#bfbfbf", zIndex: 10
          }}>{errorState?.message ? errorState.message: "🪄 Report Formatting in progress… Hang tight! "}
          </div>
        </> 
        : <>
          <div style={{ display: "flex", margin: "7px 7px", flexDirection: "row", justifyContent: "flex-end" }}>
            <PrimaryButton
              onClick={() => handleToggleView(true)}
              iconProps={{ iconName: "AutoEnhanceOn" }}
              text="Formatted"
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "5px 10px",
                whiteSpace: "nowrap",
                borderRadius: "20px 0px 0px 20px",
                background: isFormattedView ? "" : "black",
                color: "white",
              }}
            />
            <PrimaryButton
              onClick={() => handleToggleView(false)}
              text="Original"
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "5px 10px",
                whiteSpace: "nowrap",
                borderRadius: "0px 20px 20px 0px",
                background: isFormattedView ? "black" : "",
                color:  "white",
              }}
            />
          </div>
          <div
            style={{
              borderBottom: "1px solid #A5A5A5",
              display: "flex",
              flexDirection: "column",
              //height: "70px",
              boxSizing: "border-box"
            }}>
          <AddTab data={isFormattedView ? updatedReports : patientReports} setActiveTabIndex={setActiveTabIndex} activeTabIndex = {activeTabIndex} handleChangeTemplate = {handleChangeTemplate}/>
          </div>
          <div style={{ borderBottom: "1px solid #A5A5A5", paddingBottom: "7px", paddingLeft: "22px", paddingTop: "7px", height: "477px", boxSizing:"border-box", position:"relative" }}>
             
            <FroalaEditor
              tag="textarea"
              config={getConfig(isFormattedView)} 
              model={model}
              ref={editorRef}
              key={`${editReport.toString()}-${isFormattedView}`}
              onModelChange={(val) => handleModelChange(val)}
            />
            
          </div>
        </>}
        </div>
      </>
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={PrimaryButtonList}
        DefaultButtonList={DefaultButtonList}
        SecondaryButtonList={formatterLoading ? [] : SecondaryButtonList}
      />
    ),
    width: "850px",
    height: "658px"
  };

  return (
    <>
      <ModalMain
        updatedModal = {true}
        modalDetails={modalDetails}
        showModal={showFormatterPopup}
      />
    </>
  );
};

export default FormatterAgentModal;


const AddTab = (props) => {
    const {getThemeColor,themeName} = useContext(themeContext);
    const [dtReportTemplatesId,setDtReportTemplatesId] = useState([]);
    const [rsnaReportTemplateId,setRsnaReportTemplatesId] = useState([]);
    const [radioReportTemplateId,setRadioReportTemplatesId] = useState([]);
    const [dsrReportTemplateId, setDsrReportTemplateId] = useState([]);
    const { patientReports, setAlertSuccessModal, alertSuccessModal, isClientReportExist, allReportTemplates, allowCopyPaste, isRestrictionsEnabled, showFormatterPopup, setShowFormatterPopup,} = useContext(studyReportContext);
  
  useEffect(()=>{
      let dtOpt = [];
      let rsnaOpt = [];
      let radiologistOpt = [];
      let dsrOpt = [];
      if(Object.keys(allReportTemplates).length > 0){
        allReportTemplates.reportTemplates?.map((ele) => {

          dtOpt.push(ele.id);
        });
        allReportTemplates.rsnaReportTemplates?.map((ele) => {
          if(ele.title == "TUBERCULOSIS"){
            rsnaOpt.push(ele.id);
          }else
          rsnaOpt.push(ele.id);
        });
        allReportTemplates.radiologistReportTemplates?.map((ele) => {
          radiologistOpt.push(ele.id);
        });
        allReportTemplates.dsrReportTemplates?.map((ele) => {
          dsrOpt.push(ele.id);
        })

        
        setDtReportTemplatesId(dtOpt);
        setRsnaReportTemplatesId(rsnaOpt);
        setRadioReportTemplatesId(radiologistOpt);
        setDsrReportTemplateId(dsrOpt);
      }
    },[allReportTemplates])

    const getRadiologistTemplateId = (reportData) => {
      if(reportData?.reportTemplateId == null || reportData?.reportTemplateId == undefined){
        return reportData?.id;
      }else{
        return reportData?.reportTemplateId;
      }
    }

    return (<>
    <div className="table-report">
        <ul id="horizontal-list" style={{minWidth:'unset'}} >
          {props?.data?.map((report, index) => {
            return (
              <li
                onClick={() => {
                    props.setActiveTabIndex(index);
                    props.handleChangeTemplate(report, index);
                }}
                id={ report.key}
                key={index}
                className={
                    index == props.activeTabIndex ? `${themeName}-active-li li-tab` : " li-tab"
                  }
                style={{background:  getThemeColor('report-not-active-tab'),color: getThemeColor("primary-color")}}
              >
                <span>{report.text}</span>
                <span className="badge-icon-d">
                 {report.text.includes(REPORT_TITLE.TUBERCULOSIS) && process.env.REACT_APP_VDC_PLATFORM == "false"?<RBadge/>: radioReportTemplateId.includes(getRadiologistTemplateId(report.reportDetails))?<PBadge/>:
                  dtReportTemplatesId.includes(report.reportDetails?.reportTemplateId)?<DBadge/>:
                  rsnaReportTemplateId.includes(report.reportDetails?.reportTemplateId) && process.env.REACT_APP_VDC_PLATFORM == "false"?<RBadge/>:
                  isClientReportExist?<CLBadge/>: dsrReportTemplateId.includes(report.reportDetails?.reportTemplateId) || dsrReportTemplateId.includes(report.reportDetails?.id)? <LBadge/> : <DBadge/>
                 }
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </>)
};

const LoaderBar = (props) => {
  
}
